exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blocks{padding:60px 0}.blocks article p{color:#222831;font-size:1.6em;line-height:24px;margin-bottom:25px;text-align:center}.blocks figure{padding:40px 0;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-81466742","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/message/message.vue
// module id = 132
// module chunks = 0